/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExpenseDtoApiResponse } from '../../models/expense-dto-api-response';

export interface GetExpenseAsync$Plain$Params {
  id: number;
}

export function getExpenseAsync$Plain(http: HttpClient, rootUrl: string, params: GetExpenseAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExpenseDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getExpenseAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExpenseDtoApiResponse>;
    })
  );
}

getExpenseAsync$Plain.PATH = '/api/expense/{id}';
